/* tslint:disable */

import {Color} from "../drawingDataModels";
import {Injectable} from "@angular/core";
import {MeshService} from "../views/three-dview/mesh.service";
import * as THREE from "three";
import {AlertService} from "../../alert.service";
import {float} from "aws-sdk/clients/lightsail";

export class NeuronDrawingMethod {
    id: number;
    name: string; //points - lines - cylinder

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }
}

export class NeuronsDrawingOptions {
    method: NeuronDrawingMethod;
    // the thickness of neurons' line
    thickness: number;
    // this is only to flip the "range bar" so the less the value the less the resolution
    // otherwise; 0.1 is the best resolution
    userResolution: number;
    drawingResolution: number;
    minResolution: number;

    constructor() {
        this.method = NeuronsGroup.neuronsDrawingMethods.lines;

        // the thickness of neurons' line,this is only to flip the "range bar" so the less the value the less the resolution, otherwise, 0.1 is the best resolution
        this.thickness = 0.5;

        this.userResolution = 4.9;
        this.drawingResolution = 0.1;
        this.minResolution = 5;  //User resolution range starts from 0.1 to 4.9
    }
}

export class NeuronsVisualizationOptions {
    show: boolean;
    isOnlySoma: boolean;
    color: Color;
    somaSize: number; //radius
    neuronsVersion: string; //original; left or right
    drawingOptions: NeuronsDrawingOptions

    constructor(color = null) {
        this.show = true;
        this.isOnlySoma = false;
        this.color = color;
        this.somaSize = NeuronsGroup.defaultSomaSize
        this.neuronsVersion = NeuronsGroup.neuronsVersionsOptions.original;
        this.drawingOptions = new NeuronsDrawingOptions();
    }
}

export class NeuronsGroupSettings {
    isSelectAll: boolean;
    isAppendNeurons: boolean;
    isOverwriteNeurons: boolean;
    canBeDownloaded: boolean;
    isShowLabel: boolean;

    constructor(canBeDownloaded) {
        this.isSelectAll = false;
        this.isAppendNeurons = false;
        this.isOverwriteNeurons = false;
        this.canBeDownloaded = canBeDownloaded;
        this.isShowLabel = false;
    }
}

@Injectable()
export class NeuronsGroup {
    static nextGroupID = 1;
    static neuronsVersionsOptions = {
        original: 'original',
        left: 'left',
        right: 'right'
    };
    static neuronsDrawingMethods = {
        lines: new NeuronDrawingMethod(1, "Lines (Fast / No thickness)"),
        points: new NeuronDrawingMethod(2, "Points (Fast / Thickness & resolution)"),
        cylinder: new NeuronDrawingMethod(3, "Cylinder (Slower / Thickness)"),
    };
    static NBLASTSimilarityColors = {
        10: ['#00ff00', '#800026', '#bd0026', '#e31a1c', '#fc4e2a', '#fd8d3c',
            '#feb24c', '#fed976', '#ffeda0', '#ffffcc', '#ffffff'],

        9: ['#00ff00', '#800026', '#bd0026', '#e31a1c', '#fc4e2a', '#fd8d3c',
            '#feb24c', '#fed976', '#ffeda0', '#ffffff'],

        8: ['#00ff00', '#800026', '#bd0026', '#e31a1c', '#fc4e2a', '#fd8d3c',
            '#feb24c', '#ffeda0', '#ffffff'],

        7: ['#00ff00', '#800026', '#e31a1c', '#fc4e2a', '#fd8d3c', '#fed976',
            '#ffffcc', '#ffffff'],

        6: ['#00ff00', '#bd0026', '#f03b20', '#fd8d3c', '#fed976', '#ffffb2',
            '#ffffff'],

        5: ['#00ff00', '#800026', '#f03b20', '#fd8d3c', '#fecc5c', '#ffffff'],

        4: ['#00ff00', '#e31a1c', '#fd8d3c', '#fecc5c', '#ffffff'],

        3: ['#00ff00', '#ff0000', '#feb24c', '#ffffff'],

        2: ['#00ff00', '#ff0000', '#ffffff'],

        1: ['#00ff00', '#ff0000']

    };
    static defaultSomaSize = 4;

    id: number;
    name: string;
    isNBLASTResult: boolean;
    neuronsData;
    visualizationOptions;
    settings;

    constructor(name, neuronsList, canBeDownloaded, isNBLASTResult, neuronsColor = []) {
        this.id = NeuronsGroup.nextGroupID;
        NeuronsGroup.nextGroupID += 1;
        this.name = name;

        this.isNBLASTResult = isNBLASTResult;

        this.neuronsData = {
            neurons: {},
            neuronsIDs: [],
            filteredNeuronsIDs: [],
            neuronsListFilter: '',
            cycleIndex: -1
        };

        this.visualizationOptions = new NeuronsVisualizationOptions();

        this.settings = new NeuronsGroupSettings(canBeDownloaded);

        this.addNeurons(neuronsList, neuronsColor);
    };

    onChangeAppend() {
        if (this.settings.isAppendNeurons) {
            this.settings.isOverwriteNeurons = false;
        }
    };

    onChangeOverwrite() {
        if (this.settings.isOverwriteNeurons) {
            this.settings.isAppendNeurons = false;
        }
    };

    initializeNeurons(neuronsList, neuronsColor = []) {

        let neurons = [];
        let nblastColors = null;
        if (this.isNBLASTResult) {
            nblastColors = NeuronsGroup.NBLASTSimilarityColors[neuronsList.length - 1];
        }

        for (let i = 0; i < neuronsList.length; i++) {
            let neuronsData = neuronsList[i];
            // console.log("initializeNeurons ==> neuronsData ===>", neuronsData);
            let color = Color.generateRandomColor();
            if (!!neuronsColor.length) {
                color = new Color(neuronsColor[i]);
            }

            let neuron = new Neuron(neuronsData.obj_id,
                new NeuronMetaData("", "", "", "", ""),
                neuronsData,
                undefined,
                undefined,
                color,
                "");
            neurons.push(neuron);
        }

        return neurons;
    }

    addNeuron(neuron: Neuron) {
        if (this.neuronsData.neuronsIDs.indexOf(neuron.id) === -1) {
            this.neuronsData.neuronsIDs.push(neuron.id);
            this.neuronsData.neurons[neuron.id] = neuron;
            this.filterNeuronsList();
            return true;
        }
        return false;
    };

    addNeurons(neuronsData, neuronsColor = []) {
        let neurons = this.initializeNeurons(neuronsData, neuronsColor)
        // console.log("addNeurons ==> neurons ==>",neurons[0]);
        for (let i = 0; i < neurons.length; i++) {
            this.addNeuron(neurons[i]);
        }
    };

    filterNeuronsList() {
        this.neuronsData.filteredNeuronsIDs = [];
        for (let i = 0; i < this.neuronsData.neuronsIDs.length; i++) {
            let add = false;
            let neuronID = this.neuronsData.neuronsIDs[i];
            let neuron = this.neuronsData.neurons[neuronID];
            this.neuronsData.filteredNeuronsIDs.push(neuron.id);

            // add = ((neuron.id.toString().includes(this.neuronsData.neuronsListFilter)) ||
            //     (neuron.info.cell_type && neuron.info.cell_type.toLowerCase().includes(this.neuronsData.neuronsListFilter.toLowerCase())) ||
            //     (neuron.info.function && neuron.info.function.toLowerCase().includes(this.neuronsData.neuronsListFilter.toLowerCase())) ||
            //     (neuron.info.gal4 && neuron.info.gal4.toLowerCase().includes(this.neuronsData.neuronsListFilter.toLowerCase())))
            //
            // if (add) {
            //     this.neuronsData.filteredNeuronsIDs.push(neuron.id);
            // }
        }
    };

    //region Cycle through neurons
    //ToDo
    // jump_to_location(neuron_id) {
    //     let element_id = 'group_' + this.id + '_neuron_' + neuron_id.toString();
    //     $location.hash(element_id);
    //     $anchorScroll();
    // };

    cycleNeuron(shift) {
        // this.settings.isSelectAll = false;
        // this.onGroupSelectAllChange();
        //
        // if (this.neuronsData.neuronsIDs.length > 0) {
        //     if (this.neuronsData.cycleIndex >= 0 && this.neuronsData.cycleIndex < this.neuronsData.neuronsIDs.length) {
        //         let neuorn = this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]];
        //         neuorn.selected = false;
        //         // remove_neuron_from_3d_scene(neuorn, this);
        //         // NeuronsService.removeNeuronFrom3DScene(neuorn, this);
        //
        //     }
        //
        //     this.neuronsData.cycleIndex += shift;
        //
        //     if (this.neuronsData.cycleIndex < 0) {
        //         this.neuronsData.cycleIndex = this.neuronsData.neuronsIDs.length - 1;
        //     } else if (this.neuronsData.cycleIndex >= this.neuronsData.neuronsIDs.length) {
        //         this.neuronsData.cycleIndex = 0;
        //     }
        //     let neuorn = this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]];
        //     neuorn.selected = true;
        //     // add_neuron_to_3d_scene(neuorn, this);
        //     // $rootScope.draw_all_canvases();
        //
        //     // this.jump_to_location(this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]].id);
        // }
        // this.settings.isShowLabel = true;
    };

    cycleReset() {
        this.settings.isSelectAll = false;
        this.onGroupSelectAllChange();
        let neuron = this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]];
        neuron.selected = false;
        // $rootScope.remove_neuron_from_3d_scene(neuron, this);

        this.neuronsData.cycleIndex = 0;
        neuron = this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]];
        neuron.selected = true;
        // $rootScope.add_neuron_to_3d_scene(neuron, this);
        // $rootScope.draw_all_canvases();

        // this.jump_to_location(this.neuronsData.neurons[this.neuronsData.neuronsIDs[this.neuronsData.cycleIndex]].id);
        this.settings.isShowLabel = true;

    };

    //endregion

    //region Neurons group visualization options

    onGroupVisibilityChange() {
        if (this.visualizationOptions.show) {
            // $rootScope.add_neurons_group_to_3d_scene__at_once(this);
        } else {
            // $rootScope.remove_neurons_group_from_3d_scene(this);
        }
        // $rootScope.draw_all_canvases();
    };

    onGroupColorChange() {
        for (let id in this.neuronsData.neurons) {
            let neuron = this.neuronsData.neurons[id];
            neuron.updateColor(this.visualizationOptions.color);
        }
        // $rootScope.draw_all_canvases();
    };

    randomiseNeuronsColors() {
        for (let id in this.neuronsData.neurons) {
            let neuron = this.neuronsData.neurons[id];
            let newColor = Color.generateRandomColor();
            neuron.updateColor(newColor);
        }
    };

    //TODo Check an error
    onGroupSomaSizeChange(somaSize) {
        this.visualizationOptions.somaSize = somaSize;
        for (let id in this.neuronsData.neurons) {
            let neuron = this.neuronsData.neurons[id];
            neuron.activeFile.meshes.somaMesh.scale.set(somaSize, somaSize, somaSize);
        }
    };

    updateNeuronsThickness() {
        this.visualizationOptions.drawingOptions.drawingResolution = (this.visualizationOptions.drawingOptions.userResolution - this.visualizationOptions.drawingOptions.minResolution) * (-1);
        this.visualizationOptions.drawingOptions.drawingResolution = Number(this.visualizationOptions.drawingOptions.drawingResolution.toFixed(2));
    }

    updateNeuronsVersion() {

    }

    onGroupNeuronsVersionChange() {
        // show_loading();
        let neuronsWithoutChosenVersionFileCount = 0;
        for (let id in this.neuronsData.neurons) {
            let neuron = this.neuronsData.neurons[id];
            neuron.activeFile = neuron.files.original;
            if (this.visualizationOptions.neuronsVersion === NeuronsGroup.neuronsVersionsOptions.left) {
                if (neuron.files.left === null) {
                    neuronsWithoutChosenVersionFileCount += 1;
                    continue
                }
                neuron.activeFile = neuron.files.left;
            } else if (this.visualizationOptions.neuronsVersion === NeuronsGroup.neuronsVersionsOptions.right) {
                if (neuron.files.right === null) {
                    neuronsWithoutChosenVersionFileCount += 1;
                    continue
                }
                neuron.activeFile = neuron.files.right;
            }
            neuron.activeFileData = null;
        }

        let isFlippingPossible = neuronsWithoutChosenVersionFileCount < this.neuronsData.neuronsIDs.length;

        if (isFlippingPossible) {
            if (neuronsWithoutChosenVersionFileCount > 0) {
                AlertService.instance.showSuccessMsg('We are sorry, ' + neuronsWithoutChosenVersionFileCount.toString() + ' neurons have no flipped version. We will flip the others!');
            }

            setTimeout(() => {
                this.updateNeuronsVersion();
            }, 500);
        } else {
            AlertService.instance.showSuccessMsg('We are sorry, none of the neurons has a flipped version!');
            // hide_loading();
        }
    };

    onGroupSelectAllChange() {
        // // $rootScope.remove_neurons_group_from_3d_scene(this);
        // for (let id in this.neuronsData.neurons) {
        //     this.neuronsData.neurons[id].selected = this.settings.isSelectAll;
        // }
        // if (this.settings.isSelectAll) {
        //     // NeuronsService.addNeuronsGroupTo3DSceneAtOnce(this);
        // }
        // // $rootScope.draw_all_canvases();
        // this.settings.isShowLabel = false;
    };

    onNeuronSelectedChange(neuron) {
        if (!neuron.selected) {
            this.settings.isSelectAll = false;
            // $rootScope.remove_neuron_from_3d_scene(neuron, this);
        } else {
            // $rootScope.add_neuron_to_3d_scene(neuron, this);
            this.settings.isSelectAll = true;
            for (let id in this.neuronsData.neurons) {
                if (!this.neuronsData.neurons[id].selected) {
                    this.settings.isSelectAll = false;
                    break;
                }
            }
        }
        // $rootScope.draw_all_canvases();
        this.settings.isShowLabel = false;
    };

    //endregion
}

export class Neuron {
    id: number
    metaData: NeuronMetaData;
    name: string;
    jsonData: {
        original: NeuronFile,
        left: NeuronFile,
        right: NeuronFile
    }
    searchOptions: NeuronSearchOptions;
    selected: boolean;
    activeFile: NeuronFile;
    visualizationOptions: NeuronsVisualizationOptions;

    constructor(id: number, metaData: NeuronMetaData, originalJsonData: string, leftJsonData: string, rightJsonData: string, color: Color, name: string = "") {

        this.id = id;
        this.metaData = metaData;
        this.searchOptions = new NeuronSearchOptions();
        this.selected = true;
        this.visualizationOptions = new NeuronsVisualizationOptions(color);
        this.name = name;
        this.jsonData = {
            original: new NeuronFile(originalJsonData),
            left: new NeuronFile(leftJsonData),
            right: new NeuronFile(rightJsonData)
        }
        this.activeFile = this.jsonData.original;
        this.activeFile.load();
    }

    // getSoma(): Node {
    //     return this.activeFile.data.nodes[1];
    // }

    getSoma2DPosition(viewName) {

        return {
            'x': this.activeFile.data.nodes[viewName].x[0],
            'y': this.activeFile.data.nodes[viewName].y[0],
            'z': this.activeFile.data.nodes[viewName].z[0],
        }
    }


    isMeshCreated() {
        if (this.activeFile.meshes && this.activeFile.meshes.somaMesh) {
            return !!this.activeFile.meshes.activeMesh;
        }
        return false;
    }

    is2DDataCalculated(viewName: string) {
        // let soma = this.getSoma();
        return !(this.activeFile.data.nodes[viewName] === null || this.activeFile.data.nodes[viewName] === undefined);
    }

    clear2DData() {
        this.jsonData.original.clear2DData();
        this.jsonData.left.clear2DData();
        this.jsonData.right.clear2DData();
    }

    async createMesh() {
        try {
            if (!this.activeFile.meshes.somaMesh) {
                // console.log("createMesh ==>this.activeFile.data.nodes[1]==>",this.activeFile.data.nodes._3d);
                let somaPosition = new THREE.Vector3(
                    this.activeFile.data.nodes._3d.x[0],
                    this.activeFile.data.nodes._3d.y[0],
                    this.activeFile.data.nodes._3d.z[0]
                )
                // console.log("createMesh ==> somaPosition ==>",somaPosition);
                this.activeFile.createSomaMesh(somaPosition, this.visualizationOptions.somaSize, this.visualizationOptions.color, []);
            }
            if (this.visualizationOptions.drawingOptions.method === NeuronsGroup.neuronsDrawingMethods.lines) {
                this.activeFile.createLinesMesh(this.activeFile.data.nodes, this.visualizationOptions.color, []);
                this.activeFile.meshes.activeMesh = this.activeFile.meshes.linesMesh;
            }
            if (this.visualizationOptions.drawingOptions.method === NeuronsGroup.neuronsDrawingMethods.points) {
                this.activeFile.createPointsMesh(this.activeFile.data.nodes, this.visualizationOptions.color, this.visualizationOptions.drawingOptions.drawingResolution, this.visualizationOptions.drawingOptions.thickness);
                this.activeFile.meshes.activeMesh = this.activeFile.meshes.pointsMesh;
            }
            if (this.visualizationOptions.drawingOptions.method === NeuronsGroup.neuronsDrawingMethods.cylinder) {
                this.activeFile.createCylinderMesh(this.activeFile.data.nodes, this.visualizationOptions.color, this.visualizationOptions.drawingOptions.drawingResolution, this.visualizationOptions.drawingOptions.thickness);
                this.activeFile.meshes.activeMesh = this.activeFile.meshes.cylinderMesh;
            }
        } catch (e) {
            console.error(e);

        }
    }

    updateColor(newColor) {
        this.visualizationOptions.color = newColor;
        this.jsonData.original.updateMeshColor(newColor);
        this.jsonData.left.updateMeshColor(newColor);
        this.jsonData.right.updateMeshColor(newColor);
    }
}

export class NeuronFile {
    jsonData: string;
    data: {
        nodes: {
            _3d: { x: float[], y: float[], z: float[] },
            parent: []
        };
    }
    meshes: {
        somaMesh: THREE.Mesh;
        linesMesh: THREE.LineSegments;
        pointsMesh: THREE.Points;
        cylinderMesh: THREE.Group;
        activeMesh;
    }

    constructor(jsonData) {
        this.jsonData = jsonData;
        this.meshes = {
            somaMesh: null,
            linesMesh: null,
            pointsMesh: null,
            cylinderMesh: null,
            activeMesh: null,
        }
    }

    async load() {
        if (!this.data) {
            if (!this.jsonData) {
                console.error("jsonData is undefined!");
                return this.data;
            }

            let parent = this.jsonData['parent_ids'] || []; // Ensure it's an array

            this.data = {
                nodes: {
                    _3d: {
                        x: this.jsonData?.['x'] ?? 0,  // Provide default values
                        y: this.jsonData?.['y'] ?? 0,
                        z: this.jsonData?.['z'] ?? 0
                    },
                    parent: parent
                },
            };
        }
    }

    createSomaMesh(somaPosition, somaSize, color, clippingPlanes) {

        if (this.meshes.somaMesh === undefined || this.meshes.somaMesh === null) {
            this.meshes.somaMesh = MeshService.instance.createSomaMesh(somaPosition, somaSize, color, clippingPlanes);
        }
    }

    createLinesMesh(nodes, color: Color, clippingPlanes) {
        if (this.meshes.linesMesh === undefined || this.meshes.linesMesh === null) {
            this.meshes.linesMesh = MeshService.instance.createNeuronMeshLines(nodes, color, clippingPlanes);
        }
    }

    createPointsMesh(nodes, color: Color, resolution: number, thickness: number) {
        if (this.meshes.pointsMesh === undefined || this.meshes.pointsMesh === null) {
            // MIMI New
            this.meshes.pointsMesh = MeshService.instance.createNeuronMeshPoints(nodes, color, resolution, thickness);
        }
    }

    createCylinderMesh(nodes, color: Color, resolution: number, thickness: number) {
        if (this.meshes.cylinderMesh === undefined || this.meshes.cylinderMesh === null) {
            this.meshes.cylinderMesh = MeshService.instance.drawNeuronCylinder(nodes, color, thickness);
        }
    }

    updateMeshColor(newColor) {
        if (this.meshes.somaMesh) {
            // @ts-ignore
            this.meshes.somaMesh.material.color = newColor.rgb;
        }
        if (this.meshes.linesMesh) {
            // @ts-ignore
            this.meshes.linesMesh.material.color = newColor.rgb;
        }
        if (this.meshes.pointsMesh) {
            // @ts-ignore
            this.meshes.pointsMesh.material.color = newColor.rgb;
        }
        if (this.meshes.cylinderMesh) {
            // @ts-ignore
            this.meshes.cylinderMesh.children[0].material.color = newColor.rgb;
        }
    }

    clear2DData() {
        if (this.data) {
            // for (let nodeID in this.data.nodes) {
            //     let node = this.data.nodes[nodeID];
            //     node.position.dorsal = null;
            //     node.position.sagittal = null;
            //     node.position.coronal = null;
            // }


            this.data.nodes['dorsal'] = null;

            this.data.nodes['sagittal'] = null;

            this.data.nodes['coronal'] = null;

        }

    }
}

export class NeuronRegionSearchOptions {
    regionsOfSoma: boolean;
    regionsOfTips: boolean;
    regionsOfPassing: boolean;
    minimumLengthInRegion: number;

    constructor() {
        this.regionsOfSoma = true;
        this.regionsOfTips = true;
        this.regionsOfPassing = false;
        this.minimumLengthInRegion = 10;
    }
}

export class NeuronSearchOptions {
    regions: NeuronRegionSearchOptions;
    lmeasure: LMeasureSearchOptions;

    constructor() {
        this.regions = new NeuronRegionSearchOptions();
        this.lmeasure = new LMeasureSearchOptions();
    }
}

export class LMeasureSearchOptions {

}

export class NeuronMetaData {
    lab: string;
    marker: string;
    cellType: string;
    publication: string;
    function: string;

    constructor(lab, marker, cellType, publication, func) {
        this.lab = lab;
        this.marker = marker;
        this.cellType = cellType;
        this.publication = publication;
        this.function = func;
    }
}

export class Node {
    id: number;
    type: number; //Some, Tip, Branch...etc
    position: {
        _3d: THREE.Vector3,
        dorsal: THREE.Vector3,
        sagittal: THREE.Vector3,
        coronal: THREE.Vector3,
    };
    radius: number;
    parent: Node;
    children: Node[];

    constructor(id, type, position3D, radius, parent, children) {
        this.position = {
            _3d: position3D,
            dorsal: null,
            sagittal: null,
            coronal: null,
        }

        this.id = id;
        this.type = type;
        this.radius = radius;
        this.parent = parent;
        this.children = children;
    }

    addChild(childNode: Node) {
        this.children.push(childNode);
    }
}

export class Link {
    parent: Node;//start
    child: Node;//end

    constructor(parent, child) {
        this.parent = parent;
        this.child = child;
    }
}
